module.exports = __webpack_public_path__ + "static/media/navbar-archive.28492e9e.svg";